/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UpdateEmployee$Params {
      body?: {
'Id'?: string;
'FirstName'?: string;
'LastName'?: string;
'Email'?: string;
'Phone'?: string;
'Address'?: string;
'EmployeeTypeId'?: number;
'Pin'?: string;
'ImageFile'?: Blob;
}
}

export function updateEmployee(http: HttpClient, rootUrl: string, params?: UpdateEmployee$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateEmployee.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateEmployee.PATH = '/api/mng/Employee/updateemployee';
